export var FieldType = /*#__PURE__*/ function(FieldType) {
    FieldType["SingleSelect"] = "SINGLE_SELECT";
    FieldType["MultiSelect"] = "MULTI_SELECT";
    FieldType["Rating"] = "RATING";
    FieldType["Formula"] = "FORMULA";
    FieldType["Count"] = "COUNT";
    return FieldType;
}({});
// TODO: combine this and the above enum, doing this write right now coz there are lot of switch case handlings
export var KeyEventsAndIntervalFieldTypes = /*#__PURE__*/ function(KeyEventsAndIntervalFieldTypes) {
    KeyEventsAndIntervalFieldTypes["KeyEvents"] = "KEY_EVENTS";
    KeyEventsAndIntervalFieldTypes["Intervals"] = "INTERVALS";
    KeyEventsAndIntervalFieldTypes["AnalyzeIntervals"] = "ANALAYSE_INTERVALS";
    return KeyEventsAndIntervalFieldTypes;
}({});
export var FieldDataType = /*#__PURE__*/ function(FieldDataType) {
    FieldDataType["Text"] = "TEXT";
    FieldDataType["MultiLineText"] = "MULTI_LINE_TEXT";
    FieldDataType["Number"] = "NUMBER";
    FieldDataType["Boolean"] = "BOOLEAN";
    FieldDataType["Date"] = "DATE";
    FieldDataType["User"] = "USER";
    FieldDataType["Note"] = "NOTE";
    FieldDataType["Company"] = "COMPANY";
    return FieldDataType;
}({});
export var FieldTypes = /*#__PURE__*/ function(FieldTypes) {
    FieldTypes["Text"] = "TEXT";
    FieldTypes["MultiLineText"] = "MULTI_LINE_TEXT";
    FieldTypes["Number"] = "NUMBER";
    FieldTypes["Boolean"] = "BOOLEAN";
    FieldTypes["Date"] = "DATE";
    FieldTypes["SingleSelect"] = "SINGLE_SELECT";
    FieldTypes["MultiSelect"] = "MULTI_SELECT";
    FieldTypes["SingleUserSelect"] = "SINGLE_USER_SELECT";
    FieldTypes["MultiUserSelect"] = "MULTI_USER_SELECT";
    FieldTypes["Rating"] = "RATING";
    FieldTypes["Note"] = "NOTE";
    FieldTypes["Level"] = "LEVEL";
    FieldTypes["Formula"] = "FORMULA";
    FieldTypes["Count"] = "COUNT";
    FieldTypes["Assignee"] = "ASSIGNEE";
    FieldTypes["Attachment"] = "ATTACHMENT";
    return FieldTypes;
}({});
